import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import SearchBar from "./components/SearchBar";
import Title from "../../../components/Title";
import { setIsCityModalOpen } from "../../../redux/reducer/slices/commonSlice";
import MapContainer from "./components/MapContainer";
import Input from "../../../components/Input";
import Flex from "../../../components/Flex";
import Button from "../../../components/Button";
import { setGeocodeAddress, setGeocodeCoords } from "../../../redux/reducer/slices/mapSlice";
import { saveCompany } from "../../../redux/reducer/slices/companiesSlice";

const AddressSelectorForm = () => {
    const dispatch = useDispatch();
    const { currentCity } = useSelector((state) => state.common);
    const { addressGeocodeObject, isInsidePolygon } = useSelector((state) => state.map);
    const [step, setStep] = useState(1);
    const [info, setInfo] = useState({
        companyType: 1, // 1 - это компания, 2 - дом.
        name: '',
        entrance: '',
        flat: '',
        floor: '',
        comment: '',
    });
    const [deliveryInfo, setDeliveryInfo] = useState(null);

    const handleClickCity = () => {
        dispatch(setIsCityModalOpen());
    }

    const handleNext = () => {
        if (!addressGeocodeObject) {
            alert('Выберите адрес');
        } else {
            setStep(2);
        }
    };

    const handleTypeChange = (type) => {
        setInfo((prev) => ({
            ...prev,
            companyType: type,
            name: type === 2 ? 'Дом' : undefined,
        }));
    };

    const handleInputChange = (field, value) => {
        setInfo((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    const handleBack = () => {
        setStep(1);
        setInfo({
            companyType: 1,
            name: '',
            entrance: '',
            flat: '',
            floor: '',
            comment: '',
        })
        dispatch(setGeocodeAddress(null));
        dispatch(setGeocodeCoords(null));
    };

    const handleSaveAddress = () => {
        const requestData = {
            id: null,
            name: info.companyType === 1 ? (info.name || 'Компания') : 'Дом',
            address: {
                lat: addressGeocodeObject.lat,
                lng: addressGeocodeObject.lng,
                street: addressGeocodeObject.street,
                house: addressGeocodeObject.house,
                floor: info.floor || "",
                entrance: info.entrance || "",
                flat: info.flat || "",
                city: {
                    id: currentCity.id,
                    name: currentCity.name
                },
            },
            extra: {
              comment: info.comment || "",
            }
        };

        console.log(requestData);
        dispatch(saveCompany(requestData));
    };

    return (
        <>
            {step === 1 &&
                <Wrapper>
                    <Title style={{marginBottom: '32px'}} level={2}>Ваш город <span style={{borderBottom: '3px solid black', cursor: 'pointer'}} onClick={handleClickCity}>{currentCity ? currentCity.name : 'Тольятти'}</span></Title>
                    <AddressWrapper>
                        <SearchBar onClick={handleNext}/>
                    </AddressWrapper>

                    {isInsidePolygon === true && addressGeocodeObject && deliveryInfo ?
                        <ConditionsWrapper>
                            <ul>
                                {deliveryInfo.deliveryPrices.length > 0 && (
                                    deliveryInfo.deliveryPrices.map(({ orderPrice, DeliveryPrice }, index) => (
                                        <li key={index}>
                                            {+orderPrice > 0 ?
                                                <p>Заказ от {+orderPrice} р. – Доставка: <b>{+DeliveryPrice > 0 ? `${+DeliveryPrice} р.` : "бесплатно"}</b></p>
                                            :
                                                <p>Доставка: <b>{+DeliveryPrice > 0 ? `${+DeliveryPrice} р.` : "бесплатно"}</b></p>
                                            }
                                        </li>
                                    ))
                                )}
                            </ul>
                            <p>Минимальный заказ: <b>{+deliveryInfo?.minOrderPrice > 0 ? `${+deliveryInfo?.minOrderPrice}р.` : 'любая сумма'}</b></p>
                        </ConditionsWrapper>
                    : isInsidePolygon === false ?
                        <ConditionsWrapper><p>Указанная координата вне зоны доставки</p></ConditionsWrapper>
                    : !addressGeocodeObject &&
                        <ConditionsWrapper><p>Укажите адрес</p></ConditionsWrapper>
                    }

                    <MapContainer setDeliveryInfo={setDeliveryInfo}/>
                </Wrapper>
            }
            {step === 2 &&
                <Wrapper>
                    <Title style={{marginBottom: '24px'}} level={2}>Добавить новый адрес</Title>

                    <Flex style={{marginBottom: '24px'}} gap='20px'>
                        {`${addressGeocodeObject && addressGeocodeObject.locality ? `${addressGeocodeObject.locality}, ` : ''}` +
                        `${addressGeocodeObject && addressGeocodeObject.street ? `${addressGeocodeObject.street}, ` : ''}` +
                        `${addressGeocodeObject && addressGeocodeObject.house ? `${addressGeocodeObject.house}` : ''}`}
                    </Flex>

                    <Flex style={{marginBottom: '24px'}} gap='20px'>
                        <Button type={info.companyType === 1 ? 'primary' : 'default'} onClick={() => handleTypeChange(1)}>Работа</Button>
                        <Button type={info.companyType === 2 ? 'primary' : 'default'} onClick={() => handleTypeChange(2)}>Дом</Button>
                    </Flex>

                    {info.companyType === 1 && (
                        <TopInput
                            value={info.name}
                            onChange={(value) => handleInputChange('name', value)}
                            placeholder="Ваша компания"
                        />
                    )}

                    <InlineGroup>
                        <StyledInput
                            type="numeric"
                            value={info.entrance}
                            onChange={(value) => handleInputChange('entrance', value)}
                            placeholder="Подъезд"
                        />
                        <StyledInput
                            type="numeric"
                            value={info.floor}
                            onChange={(value) => handleInputChange('floor', value)}
                            placeholder="Этаж"
                        />
                        <StyledInput
                            type="numeric"
                            value={info.flat}
                            onChange={(value) => handleInputChange('flat', value)}
                            placeholder={info.companyType === 1 ? "Офис" : 'Кв.'}
                        />
                    </InlineGroup>

                    <BottomInput
                        type='textarea'
                        value={info.comment}
                        onChange={(value) => handleInputChange('comment', value)}
                        placeholder="Комментарий к адресу"
                    />

                    <Flex style={{marginTop: '24px'}} justify='space-between'>
                        <Button onClick={handleBack}>Назад</Button>
                        <Button type='primary' onClick={handleSaveAddress}>Сохранить</Button>
                    </Flex>
                </Wrapper>
            }
        </>
    );
};

export default AddressSelectorForm;

// Стили
const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 800px;
    max-height: 80vh;
    overflow: hidden;
    @media (max-width: 998px) {
        width: 600px;
    }
    @media (max-width: 798px) {
        width: auto;
    }
`;

const AddressWrapper = styled.div`
    margin-bottom: 16px;
`;

const InlineGroup = styled.div`
    display: flex;
    gap: 16px;
    align-items: center;
    @media (max-width: 798px) {
        gap: 8px;
    }
`;

const StyledInput = styled(Input)`
    @media (max-width: 798px) {
        min-height: 50px;
        font-size: 14px;
    }
`;

const TopInput = styled(StyledInput)`
    margin-bottom: 16px;
    @media (max-width: 798px) {
        margin-bottom: 8px;
    }
`;

const BottomInput = styled(StyledInput)`
    margin-top: 16px;
    @media (max-width: 798px) {
        margin-top: 8px;
    }
`;

const ConditionsWrapper = styled.div`
    position: absolute;
    bottom: 40px;
    left: 40px;
    /* right: 32px; */
    z-index: 10;
    max-width: calc(100% - 80px);
    padding: 6px 12px;
    background: #ffffff;
    border-radius: 16px;
    @media (max-width: 798px) {
        bottom: 20px;
        left: 20px;
        max-width: calc(100% - 40px);
    }
`;